import { useStore } from 'effector-react'
import { useState } from 'react'
import {
  rentalContractServicesDrawer,
  RentalServicesDrawer,
} from '~/entities/RentalService'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { useDrawer } from '~/shared/ui/Drawer'
import { ChevronRightIcon } from '~/shared/ui/icons'
import { useModal } from '~/shared/ui/Modal'
import { myPalette } from '~/shared/ui/theme'
import { formSubmit, formSubmitFx } from './model'
import { Title, ButtonWrapper } from './styled'
import { WarningModal } from './WarningModal'

export function EditRentalServices() {
  const [isDrawerShow, openDrawer, closeDrawer] = useDrawer()
  const { isModalShow, openModal, closeModal } = useModal()

  const isSubmitting = useStore(formSubmitFx.pending)
  const [selectedServicesIds, setSelectedServicesIds] = useState<string[]>([])

  const handleWarningModalOpen = ({
    rentalServices,
  }: rentalContractServicesDrawer.FormValues) => {
    if (!Array.isArray(rentalServices)) {
      snackbarEnqueued({
        message: 'Ошибка смены услуг',
        variant: 'danger',
      })
      return
    }
    setSelectedServicesIds(rentalServices)
    openModal()
  }

  const handleFormSubmit = () => {
    formSubmit({
      rentalServices: selectedServicesIds,
      fn: () => {
        closeModal()
        closeDrawer()
      },
    })
  }

  return (
    <>
      <ButtonWrapper onClick={openDrawer}>
        <Title>Управление услугами</Title>
        <ChevronRightIcon color={myPalette.white.main} />
      </ButtonWrapper>

      <RentalServicesDrawer
        isShow={isDrawerShow}
        onClose={closeDrawer}
        onSuccess={handleWarningModalOpen}
      />

      <WarningModal
        isShow={isModalShow}
        onCancel={closeModal}
        onOk={handleFormSubmit}
        isSubmitting={isSubmitting}
      />
    </>
  )
}
